import styles from '../SessionsAuthHeader.module.css'
import {MarkGithubIcon} from '@primer/octicons-react'

const StaticGithubAvatar = () => {
  return (
    <>
      <div className={styles.authFormHeaderIcon}>
        <div className={styles.authFormAvatarWrapperStatic}>
          <MarkGithubIcon className={styles.avatarCoinGithub} size={48} />
        </div>
      </div>
    </>
  )
}

export default StaticGithubAvatar
